import { SiteNav } from "../components/landing/SiteNav";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { CareSection } from "../components/landing/CareSection";
import { LegalSection } from "../components/landing/LegalSection";
import { WhySection, ReviewsSection } from "../components/landing/WhySection";
import { ContactSection } from "../components/landing/ContactSection";
import { Footer, MobileBar } from "../components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-ivory text-navy">
      <SiteNav />
      <main>
        <Hero />
        <Marquee />
        <CareSection />
        <LegalSection />
        <WhySection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
